import { ModalCustom } from "components/ModalCustom";
import { Table } from "containers/Table";
import { IDetalheLotePagamento } from "../../../../../interface/IDetalheLotePagamento";
import { formatarDinheiro } from "_utils/Money";
import { IColum } from "containers/Table/interfaces";
import { useEffect, useState } from "react";
import { HttpResponse } from "_services/api/HttpResponse";
import { HttpError } from "_services/api/HttpError";
import { IData } from "_services/api/interface/HttpResponse";
import { IEstatisticasPagamento } from "../../../../../interface/IEstatisticasPagamento";
import { LoadingEstatisticaDetalhe } from "../LoadingEstatisticaDetalhe";
import {
  ContainerFechar,
  ContainerInputPesquisa,
  ContainerTable,
  ContainerValorTotal,
  Icon,
  InputPesquisa,
  InputWrapper,
} from "./style";
import { PrimaryButton } from "components/Button/style";
import { FaPen, FaTrash } from "react-icons/fa";

interface IProps {
  dados: IDetalheLotePagamento[];
  show: boolean;
  handleClose: () => void;
  buscarEstatisticasPagamento: (
    idProcessoFinanceiroAprovar: number
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  numeroNfRecibo: string | null;
  onClickProcesso: (idProcesso: number) => void;
  onConfirmRemover: () => void;
  onConfirmSalvar: () => void;
  selectedRows: any[];
  setSelectedRows: (ids: number[]) => void;
  abrirModalEditarProcesso: (idProcesso: number) => void;
  processosAlterar: any[];
  valorTotalLoteCorrigir: number | null;
}
export function ModalDetalhesLotePagamentoCorrigir({
  dados,
  show,
  handleClose,
  buscarEstatisticasPagamento,
  numeroNfRecibo,
  onClickProcesso,
  onConfirmRemover,
  onConfirmSalvar,
  selectedRows,
  setSelectedRows,
  abrirModalEditarProcesso,
  processosAlterar,
  valorTotalLoteCorrigir,
}: IProps) {
  const [dadosTabela, setDadosTabela] = useState<IDetalheLotePagamento[]>([]);

  const [estatisticasPagamento, setEstatisticasPagamento] = useState<
    IEstatisticasPagamento[]
  >([]);

  useEffect(() => {
    if (processosAlterar.length) {
      processosAlterar.map((processo) => {
        if (processo.valorAntes != processo.valorDepois) {
          setEstatisticasPagamento(
            [...estatisticasPagamento].map((estat) => {
              if (estat.idPagamento != processo.idProcessoFinanceiroAprovar) {
                return estat;
              }

              return {
                ...estat,
                custoProcesso: processo.valorDepois,
              };
            })
          );
        }

        if (processo.nomeServicoAntes != processo.nomeServicoDepois) {
          setDadosTabela(
            [...dadosTabela].map((dadoTabela) => {
              if (
                dadoTabela.idProcessoFinanceiroAprovar !=
                processo.idProcessoFinanceiroAprovar
              ) {
                return dadoTabela;
              }

              return {
                ...dadoTabela,
                descricao: processo.nomeServicoDepois,
              };
            })
          );
        }
      });

      return;
    }

    const estatisticasIniciais = dados.map((item) => ({
      idPagamento: item.id,
      custoProcesso: null,
      servicoReceber: null,
      valorPagarFornecedor: null,
    }));
    setEstatisticasPagamento(estatisticasIniciais);

    dados.forEach((item) => {
      carregarEstatisticas(item.id);
    });

    setDadosTabela(dados);
  }, [dados, processosAlterar]);

  const carregarEstatisticas = async (idPagamento: number) => {
    const { hasErro, data } = await buscarEstatisticasPagamento(idPagamento);

    setEstatisticasPagamento((prev) =>
      prev.map((item) => {
        if (item.idPagamento != idPagamento) {
          return item;
        }

        return {
          idPagamento: idPagamento,
          qtdProcessos: hasErro ? 0 : data.qtdProcessos,
          valorPagarFornecedor: hasErro ? 0 : data.valorPagarFornecedor,
          custoProcesso: hasErro ? 0 : data.custoProcesso,
          servicoReceber: hasErro ? 0 : data.servicoReceber,
        };
      })
    );
  };

  const columns: IColum<IDetalheLotePagamento>[] = [
    {
      name: "ID",
      selector: (item: IDetalheLotePagamento) => item.id,
      omit: true,
    },
    {
      name: "Processo",
      selector: ({ idProcesso }: IDetalheLotePagamento) => (
        <div
          className="link-primary"
          style={{ cursor: "pointer" }}
          onClick={() => {
            onClickProcesso(idProcesso);
          }}
        >
          {idProcesso}
        </div>
      ),
      width: "120px",
    },
    {
      name: "Placa",
      selector: ({ placa }: IDetalheLotePagamento) => placa ?? "-",
      width: "120px",
    },
    {
      name: "Empresa",
      selector: ({ nomeEmpresa }: IDetalheLotePagamento) => nomeEmpresa ?? "-",
    },
    {
      name: "Serviço",
      selector: ({ descricao }: IDetalheLotePagamento) => descricao ?? "-",
    },
    {
      name: <span>Custos do processo</span>,
      selector: ({ id }: IDetalheLotePagamento) => {
        return (
          <LoadingEstatisticaDetalhe
            id={id}
            estatisticasPagamento={estatisticasPagamento}
            item="custoProcesso"
          />
        );
      },
      width: "145px",
    },
    {
      name: <span>Serviços a receber</span>,
      selector: ({ id }: IDetalheLotePagamento) => {
        return (
          <LoadingEstatisticaDetalhe
            id={id}
            estatisticasPagamento={estatisticasPagamento}
            item="servicoReceber"
          />
        );
      },
      width: "145px",
    },
    {
      name: "Ações",
      selector: ({ id }: IDetalheLotePagamento) => (
        <>
          <FaPen
            title="Editar processo"
            onClick={() => abrirModalEditarProcesso(id)}
            style={{ cursor: "pointer" }}
          />
        </>
      ),
      width: "90px",
    },
  ];

  const onChangePesquisa = (texto: string) => {
    if (!texto) {
      setDadosTabela(dados);
      return;
    }

    setDadosTabela(
      dados.filter((item) => {
        if (
          `${item.idProcesso}`.includes(texto) ||
          (item.placa &&
            item.placa.replace("-", "").includes(texto.replace("-", "")))
        ) {
          return true;
        }
        return false;
      })
    );
  };

  return (
    <ModalCustom
      handleClose={handleClose}
      show={show}
      centered
      size="xl"
      title={`Lote de pagamento ${numeroNfRecibo ?? ""}`}
      footer
      footerTools={
        <ContainerFechar>
          {" "}
          <PrimaryButton
            onClick={handleClose}
            outline={true}
            variante="primary"
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            onClick={onConfirmRemover}
            outline={true}
            variante="primary"
            disabled={!selectedRows.length}
          >
            <FaTrash /> Remover processos
          </PrimaryButton>
          <PrimaryButton
            onClick={onConfirmSalvar}
            variante="primary"
            disabled={!processosAlterar.length}
          >
            Salvar
          </PrimaryButton>
        </ContainerFechar>
      }
    >
      <ContainerInputPesquisa>
        <ContainerValorTotal>
          Valor total a pagar:{" "}
          <strong>
            {valorTotalLoteCorrigir
              ? formatarDinheiro(Number(valorTotalLoteCorrigir))
              : "-"}
          </strong>
        </ContainerValorTotal>
        <InputWrapper>
          <Icon />
          <InputPesquisa
            onChange={(e) => {
              onChangePesquisa(e.target.value);
            }}
            placeholder="ID Processo ou placa"
          />
        </InputWrapper>
      </ContainerInputPesquisa>
      <ContainerTable>
        <Table
          keyField="id"
          pagination={false}
          columns={columns}
          data={dadosTabela}
          loading={false}
          noSubHeader
          possuiTooltip={false}
          selectableRows
          setRowsSelected={setSelectedRows}
          headerFixo
          fixedHeaderScrollHeight="600px"
        />
      </ContainerTable>
    </ModalCustom>
  );
}
